import { Helmet } from 'react-helmet-async';

/**
 * SEO Component - Manages meta tags, Open Graph, Twitter cards, and JSON-LD structured data
 * 
 * Usage:
 * <SEO 
 *   title="Page Title"
 *   description="Page description"
 *   image="https://example.com/image.jpg"
 *   url="https://keepersexperience.com/page"
 *   type="website|article|product"
 *   jsonLd={{ ... }}
 * />
 */
export default function SEO({ 
  title = 'Keepers Experience | Hiking in Jordan', 
  description = 'Keepers Experience – Your hiking experts in Jordan. Weekly hikes, private trips & corporate adventures.',
  image = 'https://keepersexperience.com/full_logo.png',
  url = 'https://keepersexperience.com',
  type = 'website',
  jsonLd = null,
  noindex = false
}) {
  const baseUrl = 'https://keepersexperience.com';
  const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type === 'article' ? 'article' : 'website'} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Keepers Experience" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="ar_JO" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      <meta property="twitter:site" content="@keepers.experience" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
